import {
  Button,
  ButtonGroup,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { useFilterContext } from "../FeedFilter/State/FilterContext";
import React, { useCallback, useEffect, useState } from "react";
import { useInsightsPanelContext } from "./InsightsPanelContext";
import { useInterval } from "react-use";
import { useFeedContext } from "../FeedFilter/State/FeedContext";

export const MinimumNumberOfGroopitsForSummaryInsights = 2;

const countdownTimerStartInSeconds = 60;

export const InsightsReportButton = (): JSX.Element => {
  const insightsPanelContext = useInsightsPanelContext();
  const { filter } = useFilterContext();
  const feed = useFeedContext();
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [generationTimeInSeconds, setGenerationTimeInSeconds] = useState(
    countdownTimerStartInSeconds,
  );

  const createReport = useCallback(() => {
    setIsSubmitting(true);
    insightsPanelContext.setIsGeneratingReport({
      filter: filter.filter,
      groopitCount: feed.totalCount,
      reportCompleted: false,
      error: null,
    });
  }, [feed.totalCount, filter, insightsPanelContext]);

  useInterval(
    () => setGenerationTimeInSeconds(generationTimeInSeconds - 1),
    isSubmitting ? 1000 : null,
  );

  useEffect(() => {
    if (
      isSubmitting &&
      (!insightsPanelContext.isGeneratingReport ||
        insightsPanelContext.isGeneratingReport.reportCompleted ||
        insightsPanelContext.isGeneratingReport.error)
    ) {
      setIsSubmitting(false);
    }
  }, [isSubmitting, insightsPanelContext.isGeneratingReport]);

  const formatTime = (seconds: number): string => {
    const isNegative = seconds < 0;
    const absSeconds = Math.abs(seconds);
    const minutes = Math.floor(absSeconds / 60);
    const remainingSeconds = absSeconds % 60;
    return `${isNegative ? "-" : ""}${String(minutes).padStart(
      1,
      "0",
    )}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  return (
    <>
      <ButtonGroup variant="contained" color="primary" size="large">
        <Button
          fullWidth
          type="button"
          disabled={
            isSubmitting ||
            feed.loading ||
            feed.totalCount < MinimumNumberOfGroopitsForSummaryInsights
          }
          onClick={() => createReport()}
          startIcon={isSubmitting && <CircularProgress size={22} />}
          endIcon={
            isSubmitting && (
              <Typography color="primary">
                {formatTime(generationTimeInSeconds)}
              </Typography>
            )
          }
        >
          {isSubmitting ? "Generating..." : "Generate AI Insight"}
        </Button>
      </ButtonGroup>
    </>
  );
};
